import type { Update } from '@ngrx/entity';
import type { PoolInput, PoolOutput } from 'core/http/project';
import type { Uuid } from 'shared/common/types';
import { createAction, props } from '@ngrx/store';
import { createSetErrorAction, createSetLoadingAction } from 'app/store/completed-entity-state/completed-entity-state';

export const getPools = createAction('[Project Request] Get Pools');
export const savePools = createAction('[Project Store] Save Pools', props<{ pools: PoolOutput[] }>());
export const markPoolsLoaded = createAction('[Project Store] Mark Pools Loaded');

export const createPool = createAction('[Project Request] Create Pool', props<PoolInput>());
export const addPoolInStore = createAction('[Project Store] Add Pool In Store', props<PoolOutput>());

export const updatePool = createAction('[Project Request] Update Pool', props<{ id: Uuid; input: PoolInput }>());
export const updatePoolInStore = createAction('[Project Store] Update Pool In Store', props<{ update: Update<PoolOutput> }>());

export const removePool = createAction('[Project Request] Remove Pool', props<{ id: Uuid }>());
export const removePoolFromStore = createAction('[Project Store] Remove Pool From Store', props<{ id: Uuid }>());

export const setLoading = createSetLoadingAction('[Project Store] Set Pools Loading');

export const setError = createSetErrorAction('[Project Store] Set Pools Error');
